import React from 'react';
import { List } from '@mui/material';

import { Category } from 'common/types';
import OrderableListItem from './OrderableListItem';

interface Props {
	categories: Category[];
	onMoveUp?: (categoryId: string, currentIndex: number) => void;
	onMoveDown?: (categoryId: string, currentIndex: number) => void;
}

const CategoryList = (props: Props) => {
	const { categories, onMoveUp, onMoveDown } = props;

	const handleMove = (direction: 'up' | 'down') => (categoryId: string) => {
		const currentIndex = categories.findIndex((c) => c.id === categoryId);
		if (direction === 'up') {
			onMoveUp?.(categoryId, currentIndex);
		} else {
			onMoveDown?.(categoryId, currentIndex);
		}
	};

	const renderItem = (category: Category, index: number) => {
		return (
			<OrderableListItem
				id={category.id}
				key={category.id}
				label={category.name.def}
				image={category.imageUrl ?? undefined}
				onMoveUp={handleMove('up')}
				canMoveUp={index !== 0}
				onMoveDown={handleMove('down')}
				canMoveDown={index !== categories.length - 1}
			/>
		);
	};

	return <List sx={{ width: '100%' }}>{categories.map(renderItem)}</List>;
};

export default CategoryList;
